import(/* webpackMode: "eager", webpackExports: ["SecureCookiesProvider"] */ "/opt/build/repo/packages/electus/frontend/node_modules/next-client-cookies/dist/provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/fonts/index.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/node_modules/react-tooltip/dist/react-tooltip.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/data-layer-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/error-boundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/gtm-init/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/route-progress/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/session-teardown/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/skip-to-content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/authentication/auth-drawer-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/providers/i18n-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/opt/build/repo/packages/electus/frontend/src/providers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/providers/recaptcha-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/providers/support-contact/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/src/styles/global/index.css");
